"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _distributorsLinks = _interopRequireDefault(require("./distributors-links"));

var _utils = require("../../utils");

var _excluded = ["distributors", "firstRef", "itemPadding", "onChangeHandler", "returnFocus", "toggleShowDropdown"],
    _excluded2 = ["id", "region", "companies"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])),
  distributors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    companies: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      icon: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
      label: _propTypes.string,
      name: _propTypes.string,
      tag: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]),
      url: _propTypes.string,
      value: _propTypes.string
    })),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    region: _propTypes.string
  })),
  firstRef: (0, _propTypes.shape)({
    current: _propTypes.object
  }),
  itemPadding: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
  itemRefs: (0, _propTypes.shape)({
    current: _propTypes.array
  }),
  onChangeHandler: _propTypes.func,
  returnFocus: _propTypes.func,
  toggleShowDropdown: _propTypes.func
};
var reduceIndexed = (0, _ramda.addIndex)(_ramda.reduce);

var figureBaseIndex = function figureBaseIndex(distributors, index) {
  return reduceIndexed(function (acc, group, reduceIndex) {
    if (reduceIndex < index) {
      return acc + group.companies.length;
    }

    return acc;
  }, 0, distributors);
};

var labelFontObject = {
  color: "body-grey",
  fontSize: [1, 1, 0],
  fontWeight: 1,
  letterSpacing: ["1.8px", "1.8px", "1.5px"],
  lineHeight: 1
};

var clampIndex = function clampIndex(total, num) {
  return (0, _ramda.clamp)(-1, total - 1, num);
};

var DistributorsList = function DistributorsList(_ref) {
  var distributors = _ref.distributors,
      firstRef = _ref.firstRef,
      _ref$itemPadding = _ref.itemPadding,
      itemPadding = _ref$itemPadding === void 0 ? [3, 3, 4] : _ref$itemPadding,
      onChangeHandler = _ref.onChangeHandler,
      returnFocus = _ref.returnFocus,
      toggleShowDropdown = _ref.toggleShowDropdown,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var itemRefs = (0, _react.useRef)([]);

  var _useState = (0, _react.useState)(0),
      focusIndex = _useState[0],
      setFocusIndex = _useState[1];
  /**
   * Handle keyboard navigation
   */


  var handleKeydown = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    var newindex = focusIndex;

    if (event.key === "Escape") {
      toggleShowDropdown(event);
      (0, _utils.callIfFunc)(returnFocus);
    }

    if (event.key === "ArrowDown") {
      if (itemRefs.current.length > 0) {
        event.preventDefault();
        newindex = clampIndex(itemRefs.current.length, focusIndex + 1);
      }
    }

    if (event.key === "ArrowUp") {
      if (itemRefs.current.length > 0) {
        event.preventDefault();
        newindex = clampIndex(itemRefs.current.length, focusIndex - 1);
      }
    }

    if (newindex !== focusIndex) {
      if (newindex < 0) {
        (0, _utils.callIfFunc)(returnFocus);
      } else {
        itemRefs.current[newindex].focus();
      }
    }
  }, [focusIndex, toggleShowDropdown, returnFocus]);
  (0, _react.useEffect)(function () {
    if (firstRef) {
      // eslint-disable-next-line
      firstRef.current = itemRefs.current[0];
    }

    setFocusIndex(0);
    return function () {
      (0, _utils.callIfFunc)(returnFocus);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    onKeyDown: handleKeydown,
    overflowX: "hidden",
    overflowY: "auto",
    py: [0, 0, 2],
    width: 1
  }, props), (0, _utils.mapIndexed)(function (_ref2, index) {
    var id = _ref2.id,
        _ref2$region = _ref2.region,
        region = _ref2$region === void 0 ? "" : _ref2$region,
        _ref2$companies = _ref2.companies,
        companies = _ref2$companies === void 0 ? [] : _ref2$companies,
        group = _objectWithoutPropertiesLoose(_ref2, _excluded2);

    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      key: id,
      flexDirection: "column",
      minWidth: "100%",
      position: "relative",
      width: 1
    }, region && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      px: itemPadding,
      py: [2, 2, "12px"]
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, labelFontObject, region)), /*#__PURE__*/_react["default"].createElement(_distributorsLinks["default"], _extends({
      baseIndex: figureBaseIndex(distributors, index),
      itemClickHandler: onChangeHandler,
      itemFocusHandler: setFocusIndex,
      itemRefs: itemRefs,
      items: companies,
      px: itemPadding,
      toggleShowDropdown: toggleShowDropdown
    }, group)));
  }, distributors));
};

DistributorsList.propTypes = propTypes;
var _default = DistributorsList;
exports["default"] = _default;